import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import Authorization from '../../Helpers/Authorization';

const PublicRoute = ({ component: Component }) => {
  const location = useLocation();
  const params = useParams();

  if (Authorization.isLoggedIn()) {
    if (Authorization.isAdmin()) {
      return <Navigate to="/profile" replace />;
    }

    if (Authorization.getAuthUserRole() === 'CSSUPPORT') {
      return <Navigate to="/cssupport" replace />;
    }

    return <Navigate to="/track-trace" replace />;
  }

  return (
    <Component path="/track-trace" location={location} match={{ params }} />
  );
};

export default PublicRoute;
